import {useAuthStore} from "~/stores/authUser";

export default defineNuxtPlugin(async nuxtApp => {
  const authStore = useAuthStore();
  const token = useCookie('token')
  authStore.setUserToken(token.value);
})
